import { Component, OnInit } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../login/auth.service';
import { OfflineStaticDevices } from './offlinedevices';
import { OccupancyStaticDevices } from './occupancydevices';
import { AdminDashboardService } from './dashboard.service';

import { ToastyService, ToastOptions } from 'ng2-toasty';
import { NgbModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [AdminDashboardService],
})

export class AdminDashboardPage implements OnInit {
  ngOnInit() {}

  private headers: Headers;
  private url = environment.apiUrl;
  private datesSelected: NgbDateStruct[]=[];
  private deviceTimeslots: DeviceTimeslots[]=[];

  constructor(private http: Http, private authService: AuthService, private toastyService:ToastyService, private modalService: NgbModal, private adminDashboard: AdminDashboardService) {
    this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
  }

  // function from ng-bootstrap:ngb-datepicker that catches the changes in value selection
  change(value:NgbDateStruct[])
  {
    this.datesSelected=value;
    // order dates ascending
    this.datesSelected.sort(function(a,b){
      let firstDate = new Date(''.concat(b.year.toString(),'-',b.month.toString(),'-',b.day.toString()));
      let secondDate = new Date(''.concat(a.year.toString(),'-',a.month.toString(),'-',a.day.toString()));
      return secondDate.getTime() - firstDate.getTime();
    });
  }
  
  // function that clears date selection and device ID for DeviceOccupancy calendar
  clear_dates(){
    this.datesSelected=[];
    let deviceIDelem = <HTMLInputElement>document.getElementById("devIdCalendar");
    deviceIDelem.value = "";

  }

  // API function call for updating device's "description" parameter
  // TODO: check if this is obsolete and should be removed
  /*changeDeviceDescription(description: string, id: number): Promise<any> {
    return this.http
      .post(this.url+'/admin/devicesupdate/description/'+description+'/'+id, {}, {headers: this.headers})
      .toPromise()
      .then(res => res.json().result)
      .catch(this.handleError)
      .then(result => {
        let toastOptions:ToastOptions = {
            title: null,
            msg: "Device " + String(id) + " description changed!",
            showClose: true,
            timeout: 5000,
            theme: "bootstrap"
        };
        this.toastyService.success(toastOptions);
      }, err => {
        let toastOptions:ToastOptions = {
            title: null,
            msg: "Device description update failed!",
            showClose: true,
            timeout: 5000,
            theme: "bootstrap"
        };
        this.toastyService.error(toastOptions);
      });
  }*/

  // API function call for updating device's "approved" parameter
  changeDeviceApprove(approvestatus: string, id: number): Promise<any> {
    return this.http
      .post(this.url+'/admin/devicesupdate/approve/'+approvestatus+'/'+id, {}, {headers: this.headers})
      .toPromise()
      .then(res => res.json().result)
      .catch(this.handleError)
      .then(result => {
        let toastOptions:ToastOptions = {
            title: null,
            msg: "Device " + String(id) + " status changed!",
            showClose: true,
            timeout: 5000,
            theme: "bootstrap"
        };
        this.toastyService.success(toastOptions);
      }, err => {
        let toastOptions:ToastOptions = {
            title: null,
            msg: "Device status update failed!",
            showClose: true,
            timeout: 5000,
            theme: "bootstrap"
        };
        this.toastyService.error(toastOptions);
      });
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  // function that opens the window which displays all static offline devices
  openStaticOfflineWindow(){
    this.modalService.open(OfflineStaticDevices, {size: "lg", windowClass: "-preview"});
  }

  // API function call to get timeslots for specific device ID for date range
  getDeviceTimeslots(deviceID: number) {
    let year, month, day;

    // get list of dates in format "year-month-day" with leading zeros
    let dateArray = [];
    let date = "";
    for (let elem of this.datesSelected){
      year = this.pad(elem.year);
      month = this.pad(elem.month);
      day = this.pad(elem.day);
      date = year + "-" + month + "-" + day;
      dateArray.push(date);
    }

    // API call
    this.adminDashboard.getTimeslotsOccupancy(dateArray, [{id:deviceID, name:"", schedule:null}]).then(result => {
      let newDeviceSchedules = result.devices;
      let price = 0;
      let availableTs = [];
      let unavailableTs = [];
      let idx = 0;
      let totalPrice = 0;
      let totalOccupancy = 0;

      //for every date and for every timeslot in that date save info
      newDeviceSchedules.forEach(element => {
        element.schedule.forEach(element => {
          //get info for this date
          availableTs = [];
          unavailableTs = [];
          element.timeslots.forEach(element => {
            if (element.not_available != true){
              availableTs.push(element.id)
            }
            else {
              unavailableTs.push(element.id)
              price += element.price * 60;
            }
          })
          //info: deviceID, date "Day, dd.mm.yyyy", available timeslots "0-23", unavailable timeslots "0-23", price, percentage "0-100%"
          this.deviceTimeslots[idx] = new DeviceTimeslots;
          this.deviceTimeslots[idx].Id = deviceID;
          this.deviceTimeslots[idx].Date = element.date;
          this.deviceTimeslots[idx].AvailableTimeslots = availableTs;
          this.deviceTimeslots[idx].UnavailableTimeslots= unavailableTs;
          this.deviceTimeslots[idx].Price = price;
          this.deviceTimeslots[idx].PercentageOccupancy = Math.round((this.deviceTimeslots[idx].UnavailableTimeslots.length / 24)*100);

          //info: total price and occupancy for selected dates
          totalPrice += this.deviceTimeslots[idx].Price;
          totalOccupancy += this.deviceTimeslots[idx].PercentageOccupancy;

          //prepare for new date
          idx += 1;
          price = 0;
        });
      });

    // open window that will show occupancy for this device ID
    // TODO: make this window prettier, a table like presentation for 7 days per page
    let modalRef = this.modalService.open(OccupancyStaticDevices, {size: "lg", windowClass: "-preview"});
    modalRef.componentInstance.items = this.deviceTimeslots;
    modalRef.componentInstance.totalPrice = totalPrice;
    modalRef.componentInstance.totalOccupancy = Math.round(((totalOccupancy / this.deviceTimeslots.length) + Number.EPSILON) * 100) / 100;
     
    }); //end API call

  }

  /**
   * help function that inserts leading zeros
   */
  pad(num: number): string{
    let s = num + "";
    while (s.length < 2) s = "0" + s;
    return s
  }

}

// struct for collected dates for static device info
export class DeviceTimeslots {
  Id: number;
  Date: string='';
  AvailableTimeslots: number[]=[];
  UnavailableTimeslots: number[]=[];
  Price: number;
  PercentageOccupancy: number;
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/dashboard/dashboard.component.ts